import PipelineNodeIcon, { DashboardIcon } from '@components/pipelineNodes/PipelineNodeIcon.component';
import { Dashboard } from '@models/dashboard';
import { PublishPlan } from '@models/draftVersion';
import { PipelineNode, PipelineNodeRelationship } from '@models/pipelineNode';
import { SourceRecordType } from '@models/source';
import { Visualization } from '@models/visualization';
import { Pane, PaneContent } from '@pages/PageStructure.component';
import { Component, useCallback, useState } from 'react';
import { Badge, Form } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import styled from 'styled-components';


interface Props {
    loading?: boolean;
    disabled?: boolean;
    plan?: PublishPlan;
    message: string;
    onMessageChange: (m: string) => void;
}

const Container = styled.div`

.model-changes {
    padding: 5px 5px;
}

h3 {
    text-align: center;
}

.diff-table{
    height: 50vh;
}

.record-item {
    margin-bottom: 5px;
    padding: 3px;
    border-radius: 5px;

    h4 {
        padding-top: 10px;
    }
}
`

const PublishPlanChanges = (props: Props) => {
    const [saving, setSaving] = useState(false);
    const [error, setError] = useState<any>(undefined);
    const [status, setStatus] = useState('');




    if (!props.plan?.has_any_changes) {
        return <p>It looks like there are no changes to publish</p>
    }
    
    const renderPipelineNode =  (n: PipelineNode, bg_style: string) => {
        return  <div className={`col-12 record-item ${bg_style}`}>
            <div className="row">
                    <div className="col-3 ">
                        <PipelineNodeIcon node={n}/>
                    </div>
                    
                    <h4 className="col-9 text-truncate">
                        <Link to={`/node/${n.id}/config`} target="_blank">{n.name}</Link>
                    </h4>
            </div>
        </div>
    } 

    const renderPipelineNodeRelationship =  (n: PipelineNodeRelationship, bg_style: string) => {
        return <div className={`col-12 record-item ${bg_style}`}>
            <div className="row">
                <div className="col-3">
                    <DashboardIcon bgColor={'purple'} icon={"mdi mdi-transit-connection-variant"}/>
                </div>
                <h4 className="col-9 text-truncate">
                    <Link to={`/node/${n.parent_node_id}/relationships/${n.id}`} target="_blank">{n.name || 'Unnamed Relationship'}</Link>
                </h4>
            </div>
        </div>
    } 

    const renderVisualization =  (n: Visualization, bg_style: string) => {
        return <div className={`col-12 record-item ${bg_style}`}>
            <div className="row">
                <div className="col-3">
                    <DashboardIcon bgColor={'purple'} icon={"mdi mdi-chart-bar"}/>
                </div>
                <h4 className="col-9 text-truncate">
                    <Link to={`/node/${n.pipeline_node_id}/visualizations/${n.id}`} target="_blank">{n.name || 'Unnamed Visualization'}</Link>
                </h4>
            </div>
        </div>
    } 

    const renderDashboard =  (n: Dashboard, bg_style: string) => {
        return <div className={`col-12 record-item ${bg_style}`}>
            <div className="row">
                <div className="col-3">
                    <DashboardIcon bgColor={'purple'} icon={"mdi mdi-view-dashboard"}/>
                </div>
                <h4 className="col-9 text-truncate">
                    <Link to={`/dashboard/${n.id}`} target="_blank">{n.name || 'Unnamed Dashboard'}</Link>
                </h4>
            </div>
        </div>
    } 

    return (
        <Container>
        <p>This will publish everything you have in develop mode into production, which may affect reports or other nodes your stakeholders depend on.</p>
        <div className='row'>
            <Form.Group className="mb-3">
                <Form.Label>Message to include with publish:</Form.Label>
                <Form.Control as="textarea" onChange={(e) => props.onMessageChange(e.target.value)} autoFocus value={props.message} placeholder='add your message here' />
            </Form.Group>
        </div>
        <div className='diff-table'>
            <Pane><PaneContent>
            <div className="row justify-content-center">
            
                {props.plan.total_created > 0 && <div className='col-4 model-changes'>
                    <h3>Create <Badge pill bg="pliable">{props.plan.total_created}</Badge></h3>

                    {props.plan.diff.PipelineNode.created.map((r) => renderPipelineNode(r, 'alert-warning'))}
                    {props.plan.diff.PipelineNodeRelationship.created.map((r) => renderPipelineNodeRelationship(r, 'alert-warning'))}
                    {props.plan.diff.Visualization.created.map((r) => renderVisualization(r, 'alert-warning'))}
                    {props.plan.diff.Dashboard.created.map((r) => renderDashboard(r, 'alert-warning'))}

                </div>}
                {props.plan.total_updated > 0 && <div className='col-4 model-changes'>
                    <h3>Update <Badge pill bg="info">{props.plan.total_updated}</Badge></h3>
                    
                    {props.plan.diff.PipelineNode.updated.map((r) => renderPipelineNode(r, 'alert-info'))}
                    {props.plan.diff.PipelineNodeRelationship.updated.map((r) => renderPipelineNodeRelationship(r, 'alert-info'))}
                    {props.plan.diff.Visualization.updated.map((r) => renderVisualization(r, 'alert-info'))}
                    {props.plan.diff.Dashboard.updated.map((r) => renderDashboard(r, 'alert-info'))}
                </div>}
                {props.plan.total_deleted > 0 && <div className='col-4 model-changes alert-danger'>
                    <h3>Delete <Badge pill bg="danger">{props.plan.total_deleted}</Badge></h3>
                    
                    {props.plan.diff.PipelineNode.deleted.map((r) => renderPipelineNode(r, 'alert-danger'))}
                    {props.plan.diff.PipelineNodeRelationship.deleted.map((r) => renderPipelineNodeRelationship(r, 'alert-danger'))}
                    {props.plan.diff.Visualization.deleted.map((r) => renderVisualization(r, 'alert-danger'))}
                    {props.plan.diff.Dashboard.deleted.map((r) => renderDashboard(r, 'alert-danger'))}
                </div>}
            </div>
            </PaneContent></Pane>
        </div>
        </Container>
    )
}

export default PublishPlanChanges;

